import { JsonProperty } from 'json-typescript-mapper';

export class DocumentCategory {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('title')
  public title?: string;

  @JsonProperty('sortOrder')
  public sortOrder?: number;

  constructor() {
    this.id = void 0;
    this.title = void 0;
    this.sortOrder = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/document-category.model.ts